(function () {
  'use strict';

  /* ---------- Countdown band ---------- */
  var countdownEl = document.getElementById('kof-countdown');
  if (countdownEl) {
    var endTime = new Date(countdownEl.dataset.end).getTime();
    var daysEl    = countdownEl.querySelector('[data-unit="days"]');
    var hoursEl   = countdownEl.querySelector('[data-unit="hours"]');
    var minutesEl = countdownEl.querySelector('[data-unit="minutes"]');
    var secondsEl = countdownEl.querySelector('[data-unit="seconds"]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function updateCountdown() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        countdownEl.style.display = 'none';
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var days    = Math.floor(totalSeconds / 86400);
      var hours   = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ---------- Real add-to-cart for deal cards (kitsters-card-product snippet) ---------- */
  var badge = document.querySelector('[data-cart-count]');
  var toast = document.querySelector('[data-toast]');
  var toastText = toast ? toast.querySelector('[data-toast-text]') : null;
  var toastCloseBtn = toast ? toast.querySelector('[data-toast-close]') : null;
  var toastTimer;

  function showToast(msg) {
    if (!toast || !toastText) return;
    toastText.textContent = msg;
    toast.classList.remove('is-open');
    void toast.offsetWidth;
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-open'); }, 4000);
  }
  if (toastCloseBtn) {
    toastCloseBtn.addEventListener('click', function () {
      toast.classList.remove('is-open');
      clearTimeout(toastTimer);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var name = btn.getAttribute('data-name') || 'Item';
    if (!variantId) return;

    btn.disabled = true;

    // KitstersCart owns the drawer contract — which sections to request and
    // how to hand the response back. See assets/kitsters-cart-bridge.js.
    var payload = { id: parseInt(variantId, 10), quantity: 1 };

    window.KitstersCart.addToCart(payload)
      .then(function () {
        showToast(name + ' added to cart!');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('is-empty', cart.item_count === 0);
        }
      })
      .catch(function (err) {
        showToast((err && err.cartError && err.cartError.description) || 'Could not add to cart - please try again');
      })
      .finally(function () { btn.disabled = false; });
  });
})();
